module.exports = __webpack_public_path__ + "img/redpack-2.642cc3fd.png";